var map = {
	"./add.svg": "HDdA",
	"./arrow.svg": "7Hhe",
	"./cart.svg": "eBx0",
	"./clear.svg": "4KGF",
	"./coupon.svg": "1Fjq",
	"./cross.svg": "ZybG",
	"./delete.svg": "eXS7",
	"./discovery.svg": "YUbZ",
	"./index.svg": "z8O7",
	"./info-large.svg": "2/qn",
	"./info.svg": "EoBZ",
	"./logo.svg": "EFw+",
	"./member.svg": "jiW9",
	"./my.svg": "kY+R",
	"./nodata.svg": "KCuv",
	"./radio-off.svg": "+w1A",
	"./radio-on.svg": "Og+d",
	"./schedule.svg": "pTDq",
	"./seat-1.svg": "IDgg",
	"./seat-10.svg": "8QPl",
	"./seat-11.svg": "j7PS",
	"./seat-12.svg": "IKje",
	"./seat-2.svg": "r/xx",
	"./seat-3.svg": "HY7i",
	"./seat-4.svg": "Ds5O",
	"./seat-5.svg": "WDHu",
	"./seat-6.svg": "LJj4",
	"./seat-7.svg": "CF2G",
	"./seat-8.svg": "gDQ7",
	"./seat-9.svg": "+oMS",
	"./seat-occupied.svg": "2KDU",
	"./seat-priority.svg": "hvJV",
	"./seat-selected.svg": "vrIz",
	"./spin.svg": "Fzcg",
	"./tiket.svg": "G3Cc",
	"./vectorpaint.svg": "xq84"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "avz/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons \.(svg|png)$
// module id = avz/
// module chunks = 28